export default __webpack_public_path__ + "static/fsf-gray-f6332822743a2beddd1a40caf9766c4f.png";